export default __webpack_public_path__ + "9363beca75cd07a77bfc1385a3842862.png";